<template>
  <div v-if="title[0]" class="breadcrumb">
    <span @click.stop="jumpByName(title[0], 0)">{{ title[0] }}</span>
    <template v-if="title[1]">
      <span class="line">/</span>
      <span class="active" @click.stop="jumpByName(title[1], 1)">{{
        title[1]
      }}</span>
    </template>
    <template v-if="title[2]">
      <span class="line">/</span>
      <span class="active" @click.stop="jumpByName(title[2], 2)">{{
        title[2]
      }}</span>
    </template>
    <template v-if="title[3]">
      <span class="line">/</span>
      <span class="active" @click.stop="jumpByName(title[3], 3)">{{
        title[3]
      }}</span>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      path: ''
    }
  },
  computed: {
    ...mapGetters(['pathTitle', 'titlePath']),
    title() {
      return this.pathTitle[this.path] || ['', '']
    }
  },
  watch: {
    $route(to, from) {
      this.path = to.path || from.path
    }
  },
  mounted() {
    this.path = this.$route.path
  },
  methods: {
    jumpByName(name, i) {
      if (this.title.length < 3) return
      if (this.titlePath[name]) {
        this.$router.push({
          path: this.titlePath[name]
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.breadcrumb {
  height: 46px;
  background: #fff;
  display: flex;
  width: 100%;
  align-items: center;
  padding-left: 24px;
  border-top: 1px solid #e5e6eb;
  border-bottom: 1px solid #f5f7fa;
  box-sizing: border-box;
  > span {
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #909399;
    line-height: 22px;
    cursor: pointer;
    &:last-child {
      color: #1d2129;
    }
  }
  .line {
    padding: 0 10px;
  }
}
</style>
